import flags from "../featureFlags";

let _jsonData;
let _profileData;
let _baseUrl;
let _storyElementsResult;
let _custLinks;
let _experiments;

export function setExperimentsData(experiments) {
	_experiments = experiments;
}

export function getExperiment(experimentId) {
	if (_experiments) {
		return _experiments.find(exp => exp.ExperimentId === experimentId);
	}

	return undefined;
}

export function getExperimentValue(experimentId, valueKey) {
	let experiment = getExperiment(experimentId);

	if (experiment){
		let experimentObject = JSON.parse(experiment.PayloadJson);

		return experimentObject ? experimentObject[valueKey]: undefined;
	}

	return undefined;
}

export function setJsonData(jsonData) {
	_jsonData = jsonData;
}

export function getJsonData() {
	return _jsonData;
}

export function setProfileData(profileData) {
	_profileData = profileData;
}

export function getProfileData() {
	return _profileData;
}

export function getAvailabilityConfiguration() {
	return {
		suggestionLink: _profileData ? _profileData.SuggestAPurchaseLink : undefined,
		otsEnabled: _profileData != undefined ? _profileData.OnTheShelfProfileGuid && flags.onTheShelf() : false,
		hasHoldings: _profileData != undefined ? _profileData.HasCollectionConfigured : false,
	}
}

export function setBaseUrl(baseUrl) {
	_baseUrl = baseUrl;
}

export function getBaseUrl() {
	return _baseUrl;
}

export function hasData(data) {
	if (Array.isArray(data)) {
		return data.length > 0;
	} else {
		return data !== undefined && data !== null;
	}
}

export function sliceData(data, endIndex, startIndex) {
	if (data && startIndex) {
		return data.slice(startIndex, endIndex);
	} else if(data) {
		return data.slice(0, endIndex);
	}
}

export function getStoryElementsResult() {
	if (_storyElementsResult) {
		return _storyElementsResult;
	}
}

export function setStoryElementsResult(data) {
	_storyElementsResult = data;
}

export function getCustLinks() {
	return _custLinks ? _custLinks : "";
}

export function setCustLinks(data) {
	_custLinks = data;
}

/**
 * Sets the DataStore with the initial data required to render NoveList Select.
 *
 * @param {Object} data The ContentByQuery response data.
 * @param {Object} config The Config object attached to the GetProfile response data.
 * @param {string} baseUrl The correct base URL used in the ContentByQuery response
 */
export function setDataStoreWithInitialResponseData(data, config, baseUrl) {
	setJsonData(data);
	setProfileData(config);
	setBaseUrl(baseUrl);
}



// WEBPACK FOOTER //
// ./src/data/DataStore.js